<app-loader [Parent]="this"></app-loader>
@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      @if (this.Model.Device != null) {
        <actionbutton Icon="rotate" ButtonType="primary" (PerformAction)="ResetDevice()">Reset Device</actionbutton>
      }
      <form-edit-button routerLink="edit">Edit</form-edit-button>
    </app-pageheader>
    <app-tabs>
      <app-tab Title="Configuration">
        <div style="margin:0 !important;" class="columns">
          <div class="column is-6">
            <article class="panel">
              <p class="panel-heading">{{Model.Name}}</p>
              <div class="panel-block">
                <div>
                  <app-field Label="Name" class="control flex-center">{{Model.Name}}</app-field>
                  <app-field Label="Location" class="control flex-center">{{Model.LocationString}}</app-field>
                  <app-field Label="Sign Mode" class="control flex-center">{{Model.ModeName}}</app-field>
                  <app-field Label="Display Rule Set" class="control flex-center">{{Model.DisplayRuleSetName}}</app-field>
                  <app-field Label="Sleep Time" class="control flex-center">{{Model.TotalSleepTime}}</app-field>
                  <app-field Label="Day Time" class="control flex-center">{{Model.DayTime}}</app-field>
                  <app-field Label="Target Structure" class="control flex-center"></app-field>
                  <app-field Label="Brightness" class="control flex-center">Day: {{Model.DayBrightness}}, Night: {{Model.NightBrightness}}</app-field>
                  @if (Model.DisplayOverrideType != 0) {
                    <app-field Label="Display Override" class="control flex-center">{{Model.DisplayOverrideType == 2 ? "Overridden with Rule " + Model.OverrideDisplayRuleSetName : "Disabled" }}</app-field>
                  }
                </div>
              </div>
            </article>
          </div>
          <div class="column is-6">
            <app-structureviewermaps [StructureId]="Model.ParkingLevelId" [SearchTerm]="Model.Id" StructureViewerForType="SignConfiguration" [Layers]="StructureViewerLayers" [ShowLevelSelect]="false"></app-structureviewermaps>
          </div>
        </div>
        <div style="margin:0 !important;" class="columns">
          <div class="column is-6">
            <article class="panel">
              <p class="panel-heading">Hardware Assignment History</p>
              <div class="panel-block">
                <table class="table is-striped" style="width:100% !important">
                  <tr><th>Hardware Chip Id</th><th>Assigned Dates</th></tr>
                  @for (item of Model.SignAssignments; track item) {
                    <tr>
                      <td>{{item.ChipId}}</td>
                      <td>{{item.DateInstalledString}} - {{item.IsActive ? 'Now' : item.DateUninstalledString}}</td>
                    </tr>
                  }
                </table>
              </div>
            </article>
          </div>
        </div>
      </app-tab>
      @if (Model.Device != null) {
        <app-tab Title="Hardware">
          <div style="margin:0 !important;" class="columns">
            <div class="column is-6">
              <article class="panel">
                <p class="panel-heading">Sign {{HardwareModel.ChipId}}</p>
                <div class="panel-block">
                  <div>
                    <app-field Label="Chip Id" class="control flex-center">{{HardwareModel.ChipId}}</app-field>
                    <app-field Label="Sign Type" class="control flex-center">{{HardwareModel.ClassName}}</app-field>
                    <app-field Label="Private Encryption Key" class="control flex-center">{{HardwareModel.PrivateEncryptionKey}}</app-field>
                    <app-field Label="Version" class="control flex-center">{{HardwareModel.VersionNumber}}</app-field>
                    <app-field Label="Status" class="control flex-center">{{HardwareModel.Status}}</app-field>
                    <app-field Label="Most Recent Check-In" class="control flex-center">{{HardwareModel.GlobalLastCheckIn}}</app-field>
                    <app-field Label="Local Communications" class="control flex-center">Channel: {{HardwareModel.Channel}}, Power:{{HardwareModel.TxPower}}</app-field>
                  </div>
                </div>
              </article>
            </div>
          </div>
        </app-tab>
      }
      <app-tab Title="Hardware Messages">
        <app-datalistview [Columns]="Columns" [ShowMap]="false" ApiUrl="{{'messaging/SignConfiguration/hardwaremessages/'+Model.Id+'/searches'}}"
          [AllowEdit]="true" [EditAsModal]="true" [ModalComponentType]="HardwareMessageType" EditUrl="hardware/messages/:id" [Filters]="Filters">
          <app-filter-set>
            <div app-search-filter></div>
            <div app-date-filter [DateSearchProperty]="'ProcessedOn'"></div>
            <div app-search-button></div>
          </app-filter-set>
        </app-datalistview>
      </app-tab>
    </app-tabs>
  </div>
}